export type GigOpportunityType = "ONE_TIME" | "RECURRING_INTRO";

export type GigOpportunityDetails = {
  type: GigOpportunityType;
  description: string;
};

const introHeading = "Introductory gig:\n";
const introFooter = "\n\nMyTeenGig handles only this introductory gig. Any future work is arranged directly after the first gig.";

export const formatGigOpportunityDescription = ({
  type,
  description,
}: GigOpportunityDetails): string => {
  if (type === "ONE_TIME") {
    return description.trim();
  }

  return `${introHeading}${description.trim()}${introFooter}`;
};

export const parseGigOpportunityDescription = (description: string): GigOpportunityDetails => {
  if (!description.startsWith(introHeading) || !description.endsWith(introFooter)) {
    return { type: "ONE_TIME", description };
  }

  return {
    type: "RECURRING_INTRO",
    description: description.slice(introHeading.length, -introFooter.length).trim(),
  };
};
